<template>
  <div class="flex flex-col">
    <div class="flex border-b border-gray-200 mb-4">
      <label
        :class="['tab-label', activeTab === 'form' ? 'tab-active' : 'tab-inactive']"
        @click="activeTab = 'form'"
      >
        <i class="fa fa-file-alt mr-2"></i>
        Entity Information
      </label>
      <label
        :class="['tab-label', activeTab === 'attachments' ? 'tab-active' : 'tab-inactive']"
        @click="activeTab = 'attachments'"
      >
        <i class="fa fa-paperclip mr-2"></i>
        Attachments
      </label>
      <label
        :class="['tab-label', activeTab === 'messages' ? 'tab-active' : 'tab-inactive']"
        @click="activeTab = 'messages'"
      >
        <i class="fa fa-comments mr-2"></i>
        Messages
      </label>
    </div>

    <div v-show="activeTab === 'form'">
      <div v-if="vtask && vtask.applicationType === 'REGISTRATION'">
        <FormDataViewer
            v-if="vtask && formData"
            :form-data="formData"
            :value-data="vtask.data || []"
        />
      </div>
      <div v-if="vtask && vtask.applicationType === 'AFFILIATION'">
        <pre>
          {{vtask}}
        </pre>
      </div>

    </div>

    <div v-show="activeTab === 'attachments'">


      <div class="attachments-card">

        <b-row>
          <b-col cols="4">
            <table v-if="vtask && vtask.attachments && vtask.attachments.length" class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
              <thead class="text-md">
              <tr class="bg-gray-pale">
                <td colspan="12" class="px-2 py-2 font-bold">Attachments</td>
              </tr>
              <tr class="text-xs">
                <th class="px-2 py-1">#</th>
                <th class="px-2 py-1">File Name</th>
                <th class="px-2 py-1 float-end">Action</th>
              </tr>
              </thead>
              <tbody class="text-xs">
              <tr v-for="(attachment, idx) in vtask.attachments" :key="idx" style="border: solid 1px #dedede;">
                <td class="px-2 py-1">{{idx + 1}}</td>
                <td class="px-2 py-1 text-capitalize">{{attachment.title}}</td>
                <td class="px-2 py-1">
                  <button class="float-end bg-gray rounded text-white hover:bg-gray-dark px-2" @click="viewFile(attachment.fileId)">Show</button>
                </td>
              </tr>
              </tbody>
            </table>



           <div v-else class="text-center py-12 text-gray-500">
          <i class="fa fa-folder-open text-4xl mb-3 text-gray-300"></i>
          <p class="text-gray-600">No attachments available for this application</p>
        </div>
        </b-col>
        <b-col cols="8">
          <div class="bg-white shadow-lg rounded-lg overflow-hidden">
            <iframe
                v-if="fileBytes"
                :src="'data:application/pdf;base64,' + fileBytes + '#toolbar=0&navpanes=0&scrollbar=0'"
                class="w-full h-full border-0 pdf-iframe"
            ></iframe>
          </div>
        </b-col>
        </b-row>
      </div>
    </div>

    <div v-show="activeTab === 'messages'">
      <TaskMessages :task-id="vtask && vtask.id ? vtask.id : id" />
    </div>
  </div>
</template>

<script>
import {api} from "@/app/services/api.service";
import FormDataViewer from '../nir/components/FormDataViewer.vue';
import TaskMessages from '../nir/components/TaskMessages.vue';

export default {
  name: 'ForcedRegistrationDetails',
  components: { FormDataViewer, TaskMessages },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: true,
      vtask: null,
      form: null,
      formData: null,
      institutions: [],
      activeTab: 'form',
      showFile: false,
      fileToView: '',
      fileBytes: '',
    };
  },
  computed: {
    institutionName() {
      if (!this.vtask || !this.vtask.institutionId) return 'N/A';
      const inst = (this.institutions || []).find(function (i) { return i.id === this.vtask.institutionId; }.bind(this));
      return inst ? inst.name : 'N/A';
    },
  },
  watch: {
    id: {
      handler(newId) {
        if (newId) {
          this.fetchTask();
        } else {
          this.vtask = null;
          this.form = null;
          this.formData = null;
          this.loading = false;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchInstitutions();
  },
  methods: {
    fetchInstitutions() {
      api().get('/nir/api/v1/institutions?page=1&limit=1000')
        .then(function (res) {
          if (res.data && res.data.data && res.data.data.content) {
            this.institutions = res.data.data.content;
          }
        }.bind(this))
        .catch(function () {});
    },
    fetchTask() {
      if (!this.id) {
        this.loading = false;
        return;
      }
      this.loading = true;
      api().get('/nir/api/v1/applications/forced?id=' + encodeURIComponent(this.id))
        .then(function (res) {
          if (res.data && res.data.data) {
            this.vtask = res.data.data;
            this.fetchForm(this.vtask.formId);
            this.fetchFormFields(this.vtask.formId);
          }
          this.loading = false;
        }.bind(this))
        .catch(function () {
          this.loading = false;
        }.bind(this));
    },
    fetchForm(formId) {
      if (!formId) return;
      api().get('/nir/api/v1/configurations/form?id=' + encodeURIComponent(formId))
        .then(function (res) {
          if (res.data && res.data.data) this.form = res.data.data;
        }.bind(this));
    },
    fetchFormFields(formId) {
      if (!formId) return;
      api().get('/nir/api/v1/configurations/forms/fields?formId=' + encodeURIComponent(formId))
        .then(function (res) {
          if (res.data && res.data.data && res.data.data.data) {
            this.formData = res.data.data.data;
          }
        }.bind(this));
    },
    formatDate(dateStr) {
      if (!dateStr) return '—';
      return new Date(dateStr).toLocaleString();
    },

    viewFile(fileId) {
      var self = this;
      this.showFile = true;
      this.fileToView = fileId;
      api().post('/nir/api/v1/applications/attachment', { fileId: fileId })
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.data) {
              self.fileBytes = res.data.data.data;
            }
          });
    },
  },
};
</script>

<style scoped>
.details-card { background: white; border-radius: 0.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1); padding: 1.5rem; margin-bottom: 1rem; }
.tab-label { padding: 0.75rem 1.5rem; font-size: 0.875rem; font-weight: 500; border-bottom: 2px solid transparent; cursor: pointer; }
.tab-active { border-color: #157EC2; color: #157EC2; }
.tab-inactive { color: #6b7280; }
.tab-inactive:hover { color: #374151; border-color: #d1d5db; }

.pdf-iframe {
  width: 100%;
  height: 800px;
  overflow-x: auto;
  border:1px solid #b1b1b1;
  top: 0 !important;
}

.badge-count { background: #157EC2; color: #1e40af; font-size: 0.75rem; font-weight: 500; padding: 0.125rem 0.5rem; border-radius: 9999px; }
.attachments-card { background: white; border-radius: 0.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1); padding: 1.5rem; }

@media (min-width: 768px) { .md-col-span-2 { grid-column: span 2; } }
</style>
